import { useMutation } from "react-query";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { ICreateNewShoppingBagParams } from "types/ShoppingBag";
import { postUpdateUserOrderStatus } from "../requests/UserOrders";
import { useQueryUserOrdersPending } from "services/api/queries/useQueryUserOrdersPending";
import logger from "components/Logger";
import { ICardapioAppState } from "../../../redux/RootReducer";
import { queryClient } from "../../queries";
import { API_SHOPPING_BAG_QUERY_KEY } from "../queries/useQueryShoppingBag";

const path = 'services/api/mutations/useMutationUpdateUserOrderStatus.ts'

export function useMutationUpdateUserOrderStatus() {

    const query = useMutation(postUpdateUserOrderStatus, {
        onSuccess: async (data) => {
            if(data?.success) {

                logger.log(`$| FILE: ${path}`)
                logger.log(`$| onSuccess: will create new shopping bag, will await refetch pending orders`)

                // console.log(shoppingBagParams);
                queryClient.invalidateQueries(API_SHOPPING_BAG_QUERY_KEY)
                queryClient.invalidateQueries("apiUserOrdersPending")
                //await refetchPedingOrders()

                logger.log(`$| FILE: {path} const query`)
                logger.log(`$| onSuccess: will create new shopping bag, did await refetch pending orders`)
            } else {
                // console.log(data?.errors)
            }
        }, onError: (data) => {
            // console.error(data)
        }
    });
    return query;
}